//
//  The configuration is kept in AWS SSM Parameter Store
//  https://docs.aws.amazon.com/systems-manager/latest/userguide/systems-manager-parameter-store.html
//
//  The EventTool parameters can be queried using AWS CLI using the following:
//  export ENV=us-dev1
//  where env = us-dev1|us-qa1|us-production
//  aws ssm get-parameters-by-path --path /us/dev1/eventtool --recursive --with-decryption
//
//  The terraform repository git@github.com:aegaxs/axs-configurations.git is the source of parameters values
//  The file configurations\ticketing\eventtool\parameters.tf contains all the parameters
//
//  https://github.com/aegaxs/axs-configurations/tree/develop/configurations/ticketing/eventtool/parameters.tf
//
// resource "aws_ssm_parameter" "eventtool_services_api" {
//   name      = "${local.ssm_path}/configuration/servicesAPI"
//   type      = "String"
//   value     = var.eventtool_services_api
//   overwrite = true
// }
//
// Steps to update or create .env file from AWS SSM
//
// One time setup:
//   Mac download gsed: http://gridlab-d.shoutwiki.com/wiki/Mac_OSX/Gsed
//   download latest aws-env from https://github.com/Droplr/aws-env/tree/master/bin
//
//
// tslint:disable-next-line:max-line-length
// AWS_ENV_PATH=/us/dev1/eventtool AWS_REGION=us-west-2 aws-env --recursive --format=dotenv | gsed 's/.*=/\U&/; s/^/REACT_APP_/' > .env
//
/* eslint-disable */

let config = {
  environment: process.env.REACT_APP_ENVIRONMENT,
  ldId: process.env.REACT_APP_LDID,
  nrAppId: process.env.REACT_APP_NRAPPID,
  protocol: process.env.REACT_APP_PROTOCOL,
  api: process.env.REACT_APP_API,
  cmsAPI: process.env.REACT_APP_CMSAPI,
  cmsApiToken: process.env.REACT_APP_CMSAPITOKEN,
  servicesAPI: process.env.REACT_APP_SERVICESAPI,
  sessionAway: Number(process.env.REACT_APP_SESSIONAWAY),
  sessionExpired: Number(process.env.REACT_APP_SESSIONEXPIRED),
  versionService: process.env.REACT_APP_VERSIONSERVICE_URL,
  sentryDSN: process.env.REACT_APP_SENTRYDSN
};

export default config;



// WEBPACK FOOTER //
// ./config/index.js